import React, { useEffect, useState } from "react";
import {
  each,
  filter,
  find,
  includes,
  isEmpty,
  isString,
  keys,
  map,
  replace,
} from "lodash";
import Label from "components/shared/form/Label";
import ReactSelect from "react-select";
import { Filter } from "components/directory/types";
import { setSearchParam } from "helpers/tixxt-router";

export default function ProfileFieldFilters({
  currentFilter,
}: {
  currentFilter: Filter;
}) {
  const filterProfileFields = filter(
    Preload.current_network.profile_fields,
    (field) =>
      includes(
        Preload.current_network.directory_filter_profile_fields,
        field.name,
      ),
  );
  const [selectedProfileFilter, setSelectedProfileFilter] = useState<{
    [key: string]: {
      name: string;
      label: string;
      value: string;
    };
  }>({});

  useEffect(() => {
    const matchingKeys = keys(currentFilter).filter((key) =>
      /^filter\[profile\..+\]$/.test(key),
    );

    if (!isEmpty(matchingKeys)) {
      const selectedFilters = {};

      each(matchingKeys, (key) => {
        const fieldName = replace(key, /filter\[profile\.(.*?)\]/, "$1");
        const value = currentFilter[key];

        const selectedField = find(Preload.current_network.profile_fields, {
          name: fieldName,
        });

        if (selectedField && isString(value)) {
          selectedFilters[fieldName] = {
            name: fieldName,
            label: find(selectedField.options, { value })?.label || "",
            value,
          };
        }
      });

      setSelectedProfileFilter(selectedFilters);
    } else {
      setSelectedProfileFilter({});
    }
  }, [currentFilter]);

  return (
    <div className="form-horizontal mt-4 mb-2">
      {map(
        filterProfileFields,
        (field) =>
          field.options && (
            <FilterSelect
              key={field.name}
              name={field.name}
              label={field.label}
              options={field.options}
              selectedOption={selectedProfileFilter[field.name] || undefined}
            />
          ),
      )}
    </div>
  );
}

function FilterSelect({
  name,
  label,
  options,
  selectedOption,
}: {
  name: string;
  label: string;
  options: { label: string; value: string }[];
  selectedOption?: { label: string; value: string };
}) {
  return (
    <div className="control-group">
      {label && <Label label={label} />}
      <div className="controls remove-input-txt-border">
        <ReactSelect
          closeMenuOnSelect
          options={options}
          value={selectedOption || null}
          placeholder={I18n.t(
            "js.directory.members.filters.profile_field_selection.placeholder",
            { label },
          )}
          noOptionsMessage={() => I18n.t("js.plugins.select2.no_match")}
          onChange={(field) =>
            setSearchParam(`filter[profile.${name}]`, field?.value)
          }
          className="form-select-container"
          classNamePrefix="form-select"
          isSearchable
          isClearable
          unstyled
        />
      </div>
    </div>
  );
}
